export default {
    DETAIL_PAGE_REQUEST : "DETAIL_PAGE_REQUEST",
    DETAIL_PAGE_SUCCESS : "DETAIL_PAGE_SUCCESS",
    DETAIL_PAGE_FAILURE : "DETAIL_PAGE_FAILURE"
}